import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {login, sendCode, verifyCode} from "../../Redux/Thunks/loginThunks";
import {Col, Row} from 'react-bootstrap';

import {service as StreamBankAuthService} from '../../Services/StreamBankAuthService';

import {ConfirmationDialog} from '../Common/ConfirmationDialog';
import {LoginComponent} from './LoginComponent';

import {useLoginEffect} from "../../Hooks/LoginHooks";

export const LoginTimeoutPopup = (props) => {
    const { successLogic, display, onHide = () => {} } = props;
    const loginState = useSelector(state => state.loginState);
    const user = useSelector(state => state.userState.user);
    const {isVerifying, title, displayPhoneNumberForm, errors} = loginState;

    // Re-run when a fresh token arrives (userState.user changes only on a JWT
    // payload change), not only when isAuthenticated flips. When the server
    // rejects the current session while the client token is still within
    // activeUntil (e.g. permissions changed elsewhere), isAuthenticated is
    // already true as the popup opens, so a successful re-login never flips it
    // and the dismiss would otherwise never fire.
    useLoginEffect(() => {
        successLogic();
    }, [user])
    
    const dispatch = useDispatch();
    
    const getConfirmationMethod = () => {
        if (!isVerifying) {
            return {
                message: 'Confirm Login',
                action: () => dispatch(login()),
            };
        }

        if (displayPhoneNumberForm) {
            return {
                message: 'Send Code',
                action: () => dispatch(sendCode()),
            };
        }

        return {
            message: 'Submit',
            action: () => dispatch(verifyCode()),
        };
    };

    return <ConfirmationDialog
                Title={title || 'Login Timeout'}
                Body={
                    [
                        !isVerifying &&
                        <Row key={1}>
                            <Col xs={12}>
                                <p>Your login has timed out. Please enter your password to re-confirm your login.</p>
                            </Col>
                        </Row>,
                        (!isVerifying && errors.login) &&
                        <Row key={2}>
                            <Col xs={12}>
                                <p className="sb-login-popup-container-error-message">{errors.login}</p>
                            </Col>
                        </Row>,
                        <Row key={3}>
                            <Col xs={12}>
                                <LoginComponent
                                    ForgotPassword={() => {}}
                                    HideButtons
                                />
                            </Col>
                        </Row>
                    ]
                }
                CancelButtonMessage={isVerifying ? 'Cancel' : 'Log Out'}
                ConfirmationButtonMessage={getConfirmationMethod().message}
                Display={display}
                OnClose={async () => {
                    await StreamBankAuthService.Logout();
                    onHide?.();
                }}
                OnConfirm={() => getConfirmationMethod().action()}
                OnCustom={isVerifying && !displayPhoneNumberForm ? () => dispatch(sendCode()) : null}
                CustomButtonMessage={`Resend ${loginState.timer > 0 ? `(${loginState.timer}s)` : 'Code'}`}
                DisableCustomButton={loginState.timer > 0}
                className="sb-login-popup-container"
            />;
};

